module.exports = __webpack_public_path__ + "img/messengers-coin.f5f3129.webp";